import { useEffect, useState } from "react";

/**
 * Returns a string of dots that are animated from 0 to 3.
 * Warning: make sure to use this hook in a component that can be unmounted,
 * otherwise the interval will not be cleared and rerenders will continue to
 * happen.
 * @param intervalMs - The interval at which the dots are updated.
 * @returns A string of dots that are animated from 0 to 3.
 */
export function useIsThinkingDots(intervalMs = 500) {
  const [dots, setDots] = useState("");

  useEffect(() => {
    // Animation loop for the dots
    const interval = setInterval(() => {
      setDots((prevDots) => {
        if (prevDots.length >= 3) {
          return "";
        }

        return `${prevDots}.`;
      });
    }, intervalMs);

    return () => clearInterval(interval);
  }, [intervalMs]);

  return dots;
}
